import script from "./TextEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextEditor.vue?vue&type=script&lang=ts&setup=true"

import "./TextEditor.vue?vue&type=style&index=0&id=5c66bf46&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c66bf46"]])

export default __exports__